module.exports = __webpack_public_path__ + "static/img/12.08c232d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/5/eng/12.png
// module id = oLD/
// module chunks = 0